/* import __COLOCATED_TEMPLATE__ from './external-conversation-banner.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Conversation from 'embercom/objects/inbox/conversation';
import type IntlService from 'embercom/services/intl';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

interface Args {
  conversation: Conversation;
}

interface Signature {
  Args: Args;
}

export default class ExternalConversationBannerComponent extends Component<Signature> {
  @service declare intl: IntlService;

  get externalSystemName(): string {
    let externalType = this.args.conversation.externalType;

    if (!externalType) {
      return '';
    }

    if (this.args.conversation.isZendeskConversation) {
      /* eslint-disable-next-line @intercom/intercom/no-bare-strings */

      return 'Zendesk';
    }

    if (this.args.conversation.isSalesforceConversation) {
      /* eslint-disable-next-line @intercom/intercom/no-bare-strings */
      return 'Salesforce';
    }

    if (this.args.conversation.isHubspotConversation) {
      /* eslint-disable-next-line @intercom/intercom/no-bare-strings */
      return 'Hubspot';
    }

    if (this.args.conversation.isFreshdeskConversation) {
      /* eslint-disable-next-line @intercom/intercom/no-bare-strings */
      return 'Freshdesk';
    }

    return '';
  }

  get icon(): InterfaceIconName {
    let externalType = this.args.conversation.externalType;

    if (!externalType) {
      return 'info';
    }

    if (this.args.conversation.isZendeskConversation) {
      return 'zendesk';
    }

    if (this.args.conversation.isSalesforceConversation) {
      return 'salesforce';
    }

    if (this.args.conversation.isHubspotConversation) {
      return 'hubspot';
    }

    return 'info';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ExternalConversationBanner': typeof ExternalConversationBannerComponent;
    'inbox2/external-conversation-banner': typeof ExternalConversationBannerComponent;
  }
}
